import { ACCOUNT_TYPES, accountTypeOf, compatibleRoles, roleNames } from '@Config/accountTypes';

const cleanCuit = value => value.trim().replace(/[-\s]/g, '');
export const initialUserForm = (user = null) => ({
  accountType: String(user ? accountTypeOf(user) : 1), roles: roleNames(user),
  cuit: user?.username || '', onBehalf: !!user?.producerCuit, producerCuit: user?.producerCuit || '',
  email: user?.email || '', firstName: user?.firstName || '', lastName: user?.lastName || '',
  phoneNumber: user?.phoneNumber || '', status: ['blocked', 'inactive'].includes(user?.status) ? 'blocked' : 'active',
  emailConfirmed: user?.emailConfirmed ?? true, password: '', confirmPassword: ''
});
export const changeAccountType = (form, accountType, catalog) => ({ ...form, accountType,
  onBehalf: accountType === '1' && form.onBehalf,
  roles: form.roles.filter(name => compatibleRoles(catalog, accountType).some(role => role.name === name)) });
export const validateUserForm = (form, editing, catalog = []) => {
  const errors = {};
  if (!ACCOUNT_TYPES.some(type => String(type.value) === form.accountType)) errors.accountType = 'La cuenta necesita revisión administrativa antes de editarse.';
  const allowed = compatibleRoles(catalog, form.accountType).map(role => role.name);
  if (form.roles.length !== 1) errors.roles = 'Seleccione un único rol compatible.';
  else if (form.roles.some(role => !allowed.includes(role))) errors.roles = 'Un rol asignado no es compatible con el tipo de cuenta. Revise la configuración.';
  if (form.accountType === '1' && !/^\d{11}$/.test(cleanCuit(form.cuit))) errors.cuit = 'El CUIT debe tener 11 dígitos';
  if (form.accountType === '1' && form.onBehalf) {
    if (!/^\d{11}$/.test(cleanCuit(form.producerCuit))) errors.producerCuit = 'Ingrese el CUIT del productor responsable';
    else if (cleanCuit(form.cuit) === cleanCuit(form.producerCuit)) errors.producerCuit = 'El gestor no puede ser su propio responsable';
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) errors.email = 'Ingrese un correo electrónico válido';
  if (!form.firstName.trim()) errors.firstName = 'El nombre es obligatorio';
  if (!form.lastName.trim()) errors.lastName = 'El apellido es obligatorio';
  if ((!editing || form.password) && form.password.length < 6) errors.password = 'La contraseña debe tener al menos 6 caracteres';
  if (form.password !== form.confirmPassword) errors.confirmPassword = 'Las contraseñas no coinciden';
  if (form.phoneNumber && !/^\+?[\d\s\-()]+$/.test(form.phoneNumber)) errors.phoneNumber = 'Ingrese un teléfono válido';
  return errors;
};
export const userFormPayload = (form, user) => ({
  userName: user?.username || (form.accountType === '1' ? cleanCuit(form.cuit) : form.email.trim()),
  email: form.email.trim(), firstName: form.firstName.trim(), lastName: form.lastName.trim(),
  phoneNumber: form.phoneNumber.trim(), accountType: user ? accountTypeOf(user) : Number(form.accountType),
  roles: [...new Set(form.roles)], producerCuit: form.accountType === '1' && form.onBehalf ? cleanCuit(form.producerCuit) : null,
  status: form.status, emailConfirmed: form.emailConfirmed,
  ...(form.password ? { password: form.password } : {})
});
